import { render } from "./CategoryStrip.vue?vue&type=template&id=05aa7d7a&scoped=true"
import script from "./CategoryStrip.vue?vue&type=script&lang=js"
export * from "./CategoryStrip.vue?vue&type=script&lang=js"

import "./CategoryStrip.vue?vue&type=style&index=0&id=05aa7d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa7d7a"]])

export default __exports__